export class GetMerchantProductRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  merchantCode: string | null = null;
  providerId: string | null = null;
  categoryId: string | null = null;
  productCode: string | null = null;
}

export class CreateMerchantProductParams {
  id: string = '';
  category_id: string = '';
  merchant_code: string = '';
  provider_id: string = '';
  product_code: string = '';
  fee_merchant: number = 0;
  fee_provider: number = 0;
  fee: number = 0;
  percent_price: number = 0;
  active: number = 1; // default active

  // Optional display fields (if needed from response DTO)
  product_name?: string;
  merchant_name?: string;
  provider_name?: string;
  category_name?: string;
  status_name?: string;
}

export class UpdateMerchantProductRequestParams extends CreateMerchantProductParams {
  oldPassword?: string;
}

export interface MerchantProductData {
  id: string;
  category_id: string;
  merchant_code: string;
  provider_id: string;
  product_code: string;
  fee_merchant: number;
  fee_provider: number;
  fee: number;
  percent_price: number;
  active: number;

  // Optional display fields from response (not needed in request)
  product_name?: string;
  merchant_name?: string;
  provider_name?: string;
  category_name?: string;
  status_name?: string;
}

export interface GetMerchantProductResponse {
  code: number;
  message: string;
  data: MerchantProductData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetMerchantProductByIdResponse {
  code: number;
  message: string;
  data: MerchantProductData;
}

export interface DeleteMerchantProductByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
